import _ from 'lodash';
import diffValue from './main.js';
import isObject from './isObject.js';

export default function diffObject(baseline, obj, options = {}) {
  if (!isObject(baseline)) {
    return obj;
  }

  _.defaults(options, { ignoreMissingProperties: false });

  const diff = {};

  _.forIn(obj, (value, key) => {
    if (!_.has(baseline, key) && value !== '$remove') {
      diff[key] = value;
    } else if (isObject(value) || _.isArray(value)) {
      const propDiff = diffValue(baseline[key], value, options);
      if (propDiff) {
        diff[key] = propDiff;
      }
    } else if (
      _.has(baseline, key) &&
      !_.isEqual(value, baseline[key]) &&
      !(_.isNil(value) && _.isNil(baseline[key]))
    ) {
      diff[key] = value;
    }
  });

  if (!options.ignoreMissingProperties) {
    _.forIn(baseline, (value, key) => {
      if (!_.has(obj, key)) {
        diff[key] = '$remove';
      }
    });
  }

  return _.isEmpty(diff) ? null : diff;
}
